// src/pages/ProductReplaceRecord/ProductReplaceRecordSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { deleteProductReplaceRecord, fetchProductReplaceRecord } from "./ProductReplaceRecordThunk";

const initialState = {
  list: [],
  filters: {
    filterType: "All",
    recordType: "without item",
    fromDate: null,
    toDate: null,
  },
  loading: false,
  error: null,
};

const productReplaceRecordSlice = createSlice({
  name: "productReplaceRecord",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductReplaceRecord.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductReplaceRecord.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchProductReplaceRecord.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteProductReplaceRecord.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteProductReplaceRecord.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteProductReplaceRecord.rejected, (state) => {
        state.loading = false;
      });

  },
});

export const { setFilters } = productReplaceRecordSlice.actions;
export default productReplaceRecordSlice.reducer;
